export enum GanChoongType {
  NULL = 0,
  SMALL,
  BIG,
}
